/* BB: size is not pre-selected on the PDP (2026-09-30).
   Dawn always needs a checked radio per option, so the real radios stay as they are.
   This layer makes the size row look unchosen until she taps a size, relabels both
   add-to-cart buttons, and blocks the add until a size is chosen. The size she picks
   is remembered for the next shirt. */
(function () {
  if (window.bbSizeChoice) return;
  window.bbSizeChoice = true;
  var KEY = 'bb_size';
  var PROMPT = 'Choose Your Size';

  function store(v) { try { if (v === undefined) return localStorage.getItem(KEY); localStorage.setItem(KEY, v); } catch (e) { return null; } }

  function init() {
    var radios = document.querySelector('variant-radios');
    if (!radios) return;
    var fs = Array.prototype.find.call(radios.querySelectorAll('fieldset'), function (f) {
      var l = f.querySelector('legend');
      return l && /^\s*size\b/i.test(l.textContent);
    });
    if (!fs) return;
    var mainBtn = document.querySelector('[id^="ProductSubmitButton-"]');
    var stickyBtn = document.querySelector('[id^="StickyProductSubmitButton-"]');
    var stickySize = document.querySelector('.sticky-atc .selected-variant-option[data-option-name="Size"]');
    var chosen = false;

    var note = document.createElement('p');
    note.className = 'bb-size-note';
    note.setAttribute('role', 'status');
    note.textContent = 'Please choose a size';
    var leg = fs.querySelector('legend');
    if (leg && leg.nextSibling) fs.insertBefore(note, leg.nextSibling); else fs.appendChild(note);

    function label(btn) {
      if (!btn || btn.hasAttribute('disabled')) return;
      var s = btn.querySelector('span');
      if (s && s.textContent.trim() !== PROMPT) s.textContent = PROMPT;
    }
    // V43 (2026-10-19): until she picks a size, show the lowest size price as "From $24.95".
    var priceBox = document.querySelector('[id^="price-"][role="status"]');
    var minCents = null;
    try {
      var vs = radios.getVariantData() || [];
      var ps = vs.map(function (v) { return v.price; });
      if (ps.length && Math.min.apply(null, ps) !== Math.max.apply(null, ps)) minCents = Math.min.apply(null, ps);
    } catch (e) {}
    var painting = false;
    var stickyPrice = document.querySelector('.sticky-atc .price-container');
    function paintPrice() {
      if (minCents === null || chosen) return;
      var txt = 'From $' + (minCents / 100).toFixed(2);
      [priceBox && priceBox.querySelector('.price-item--regular'), stickyPrice && stickyPrice.querySelector('span')].forEach(function (el) {
        if (el && el.textContent.trim() !== txt) { painting = true; el.textContent = txt; painting = false; }
      });
    }
    // Once a size is chosen, any "From" left behind (the sticky bar is not re-rendered) shows the real price.
    function realPrice() {
      if (!chosen || !radios.currentVariant) return;
      var real = '$' + (radios.currentVariant.price / 100).toFixed(2);
      var main = priceBox && priceBox.querySelector('.price-item--regular');
      if (main && /^From /.test(main.textContent.trim())) main.textContent = real;
      // The sticky bar never re-renders on a variant change, so keep it on her size's price.
      var sp = stickyPrice && stickyPrice.querySelector('span');
      if (sp && sp.textContent.trim() !== real) { painting = true; sp.textContent = real; painting = false; }
    }
    radios.addEventListener('change', function () { setTimeout(realPrice, 0); setTimeout(realPrice, 600); });
    [priceBox, stickyPrice].forEach(function (box) {
      if (box) new MutationObserver(function () { if (!painting) { paintPrice(); realPrice(); } }).observe(box, { childList: true, subtree: true, characterData: true });
    });
    function paint() {
      paintPrice();
      fs.classList.toggle('bb-size-unset', !chosen);
      document.documentElement.classList.toggle('bb-size-needed', !chosen);
      if (!chosen) {
        label(mainBtn); label(stickyBtn);
        if (stickySize) stickySize.textContent = 'Size: choose';
      }
    }
    // Dawn rewrites the button text after every variant change; put the prompt back.
    [mainBtn, stickyBtn].forEach(function (b) {
      if (!b) return;
      new MutationObserver(function () { if (!chosen) label(b); }).observe(b, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
    });
    if (stickySize) new MutationObserver(function () { if (!chosen && stickySize.textContent !== 'Size: choose') stickySize.textContent = 'Size: choose'; }).observe(stickySize, { childList: true, characterData: true, subtree: true });

    function choose(value) {
      var was = chosen;
      chosen = true;
      if (!was && priceBox && radios.currentVariant) {
        [priceBox.querySelector('.price-item--regular'), stickyPrice && stickyPrice.querySelector('span')].forEach(function (el) {
          if (el && /^From /.test(el.textContent.trim())) el.textContent = '$' + (radios.currentVariant.price / 100).toFixed(2);
        });
      }
      store(value);
      fs.classList.remove('bb-size-ask');
      paint();
      var restore = window.variantStrings && window.variantStrings.addToCart;
      [mainBtn, stickyBtn].forEach(function (b) {
        var s = b && b.querySelector('span');
        if (s && !b.hasAttribute('disabled') && s.textContent.trim() === PROMPT) s.textContent = restore || 'Add to cart';
      });
      if (stickySize) stickySize.textContent = 'Size ' + value;
    }

    // A tap on any size counts, including the one that is already checked underneath.
    fs.addEventListener('click', function (e) {
      var lab = e.target.closest('label');
      var input = lab ? document.getElementById(lab.getAttribute('for')) : (e.target.matches('input') ? e.target : null);
      if (!input || input.classList.contains('disabled')) return;
      choose(input.value);
    });

    function ask(e) {
      if (chosen) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      fs.classList.remove('bb-size-ask');
      void fs.offsetWidth;
      fs.classList.add('bb-size-ask');
      var y = fs.getBoundingClientRect().top + window.scrollY - 140;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }
    [mainBtn, stickyBtn].forEach(function (b) { if (b) b.addEventListener('click', ask, true); });
    document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(function (f) { f.addEventListener('submit', ask, true); });

    // Her remembered size, if this shirt has it in stock. Applied after every deferred
    // script has run: before that Dawn's variant update throws inside updateMedia and
    // never writes the new variant id into the form.
    paint();
    function applySaved() {
      var saved = store();
      var target = saved && Array.prototype.find.call(fs.querySelectorAll('input[type="radio"]'), function (i) { return i.value === saved && !i.classList.contains('disabled'); });
      if (!target || chosen) return;
      if (!target.checked) {
        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var form = document.querySelector('#product-form-' + radios.dataset.section + ' [name="id"]');
      var cur = radios.currentVariant;
      if (form && cur && String(form.value) !== String(cur.id) && radios.onVariantChange) {
        try { radios.onVariantChange(); } catch (e) {}
      }
      var held = form && radios.getVariantData().find(function (v) { return String(v.id) === String(form.value); });
      var ok = held && held.options.indexOf(saved) !== -1;
      if (ok) choose(saved);
    }
    if (document.readyState === 'complete') applySaved(); else window.addEventListener('load', applySaved);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
